import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { appStore } from "@store/appStore";
import OrganizationMultiPicker from "@/shared/components/OrganizationPicker/OrganizationMultiPicker";
import { clientDashboardEvents } from "../clientDashboardEvents";

export default function OrganizationSelect() {
    const appSnap = useSnapshot(appStore);
    const snap = useSnapshot(clientDashboardEvents);
    const orgs = appSnap.loggedInUser?.permissions?.organizations ?? [];

    useEffect(() => {
        if (orgs.length === 1 && clientDashboardEvents.orgIds[0] !== orgs[0].id) {
            clientDashboardEvents.triggerOrgsChanged([orgs[0].id]);
        }
    }, [orgs]);

    if (orgs.length <= 1) return null;

    return (
        <div className="dash-filter dash-filter--org">
            <OrganizationMultiPicker
                value={[...snap.orgIds]}
                onChange={(ids) => clientDashboardEvents.triggerOrgsChanged(ids)}
                placeholder="All Orgs"
            />
        </div>
    );
}
